import { render, staticRenderFns } from "./SkillGap.vue?vue&type=template&id=6346216f&scoped=true&"
import script from "./SkillGap.vue?vue&type=script&lang=ts&"
export * from "./SkillGap.vue?vue&type=script&lang=ts&"
import style0 from "./SkillGap.vue?vue&type=style&index=0&id=6346216f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6346216f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
